import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionService } from '../../core/authorization/permission.service';
import { PlatformContextService } from '../../core/platform/platform-context.service';
import { VA_CAPABILITIES } from './vacation.models';

export const vacationGuard: CanActivateFn = async () => {
  const permissions = inject(PermissionService), context = inject(PlatformContextService), router = inject(Router);
  if (!permissions.isLoaded() && !await permissions.load()) { context.markApplicationError(); return false; }
  return VA_CAPABILITIES.some(code => permissions.hasPermission(code)) ? true : router.createUrlTree(['/access-denied']);
};
